import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Search, Crown, Megaphone } from "lucide-react";

const STATUS = { approved: "text-emerald-400", pending: "text-gold", rejected: "text-red-300", "not applied": "text-text-muted" };

export function ModelsList({ onOpen }) {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const load = () => api.get("/admin/users", { params: { kind: "models", search: q } }).then(({ data }) => setRows(data));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);
  return (
    <div data-testid="models-panel" className="space-y-6">
      <p className="text-sm text-text-muted">Creators and creator applicants, including everyone who joined from a creator ad. Regular members are under Users.</p>
      <div className="flex items-center gap-2 border-b border-white/15 py-2 max-w-md">
        <Search size={15} className="text-text-muted" />
        <input data-testid="models-search" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()}
          placeholder="Search models…" className="flex-1 bg-transparent outline-none text-sm" />
      </div>
      {!rows ? <p className="text-text-muted">Loading…</p> : !rows.length ? <p data-testid="models-empty" className="text-text-muted italic">No models yet.</p> : (
        <div className="border border-white/8 rounded-2xl bg-surface divide-y divide-white/5">
          {rows.map((m) => (
            <button key={m.id} data-testid={`model-row-${m.id}`} onClick={() => onOpen(m.id)} className="w-full flex flex-wrap items-center gap-3 p-4 text-left hover:bg-white/[0.02]">
              <img src={m.photo_url || "https://images.unsplash.com/photo-1637059880830-59a90102de77"} alt="" className="w-10 h-10 rounded-full object-cover" />
              <div className="min-w-0 flex-1">
                <p className="text-sm flex items-center gap-2">{m.stage_name || m.display_name}
                  {m.founding_creator && <Crown size={12} className="text-gold" />}
                  {m.from_creator_ad && <span className="text-[9px] uppercase tracking-[0.12em] text-gold border border-gold/40 px-1.5 rounded flex items-center gap-1"><Megaphone size={9} /> ad</span>}
                </p>
                <p className="text-xs text-text-muted break-all">{m.email}{m.country ? ` · ${m.country}` : ""} · from {m.source}</p>
              </div>
              <span data-testid={`model-status-${m.id}`} className={`text-[10px] uppercase tracking-[0.15em] ${STATUS[m.application_status] || "text-text-muted"}`}>
                {m.is_creator ? "creator" : m.application_status}
              </span>
              <span className={`text-[10px] ${m.age_verified ? "text-emerald-400" : "text-amber-300"}`}>{m.age_verified ? "ID verified" : "ID pending"}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
